export default function sortSearchResults(searchText: string) {
  // Return first the results that start with the searchText
  const searchLower = searchText.toLowerCase()

  return (a: string, b: string) => {
    const aStarts = a.toLowerCase().startsWith(searchLower)
    const bStarts = b.toLowerCase().startsWith(searchLower)

    if (aStarts && !bStarts) {
      return -1
    }
    if (!aStarts && bStarts) {
      return 1
    }
    return a.localeCompare(b)
  }
}
